exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.campervanListImage{\n  border-radius: 10%;\n\n}\n\n.campervanSubtitle{\n  font-size: 14px;\n}\n\nimg:hover {\n  cursor: pointer;\n}\n\np:hover{\n  cursor: pointer;\n}\n\nimg{\n  margin-bottom: 5px;\n\n}\n\n.campervanList{\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.userListImage {\n  border-radius: 50%;\n}\n\n.userListSubtitle {\n  font-size: 14px;\n}\n\nimg:hover {\n  cursor: pointer;\n}\n\np:hover{\n  cursor: pointer;\n}\n\nimg {\n  padding-bottom: 5px;\n}\n\n.userlist {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/campervans/campervans.component.css
// module id = ../../../../../src/app/components/campervans/campervans.component.css
// module chunks = main